import React from 'react';

import { factory } from '../positions/asset-position-details/asset-position-details-container';
import AssetPositionDetails from '../positions/asset-position-details/asset-position-details';

import FxForwardsChartHeader from './fx-forwards-chart-header';

export default factory({
  rowFragmentExtend: {
    fxForwardRate: true,
    marketValue: true,
  },

  mapperExtend: ({ fxForwardRate, currency }) => ({
    chartHeaderValue: fxForwardRate,
    chartHeaderValueUnit: currency,
  }),

  component: props =>
    <AssetPositionDetails {...props} chartHeaderComponent={FxForwardsChartHeader} />,
});
